import React, { ReactNode } from 'react';
import { PrefixStyled, SuffixStyled, UnderlineTabCellStyled } from './UnderlineTabs.styled';

export interface ITabProps {
  onClick?: () => void;
  prefix?: ReactNode | string;
  suffix?: ReactNode | string;
  text: ReactNode | string;
}

export interface ICellProps {
  tabWidth?: string;
  tabContent?: string;
  marginValue?: string;
}

export interface IUnderlineTabProps {
  isActive: boolean;
  tab: ITabProps;
  cell?: ICellProps;
}

export const UnderlineTab: React.FC<IUnderlineTabProps> = ({ tab, cell, isActive }) => {
  return (
    <UnderlineTabCellStyled
      isActive={isActive}
      onClick={tab.onClick}
      tabWidth={cell?.tabWidth}
      tabContent={cell?.tabContent}
      marginValue={cell?.marginValue}
      data-test-id={`underline-tab-${tab.text}`}
    >
      {tab.prefix ? <PrefixStyled data-test-id={`underline-tab-${tab.text}-prefix`}>{tab.prefix}</PrefixStyled> : null}
      {tab.text}
      {tab.suffix ? <SuffixStyled data-test-id={`underline-tab-${tab.text}-suffix`}>{tab.suffix}</SuffixStyled> : null}
    </UnderlineTabCellStyled>
  );
};
